import React from "react";

const SalesProductionEntry=()=>{
    return(
        <>

            <div className="card my-3">
                <div className="card-header"><h3>MIS Entry</h3></div>
                <div className="card-body">
                    <div className="row ">
                        <div className="col-lg-2">Month
                            <input type="text" className="form-control" id="month" name="month"></input>
                        </div>
                        <div className="col-lg-2">Target
                            <input type="number" className="form-control" id="target" name="target" ></input>
                        </div>                      
                        <div className="col-lg-2">Unit
                            <input type="text" className="form-control" id="unit" name="unit"></input>
                        </div>

                        <hr className="my-3"/>
                        <div className="col-lg-2">Pro.Qty
                            <input type="number" className="form-control" id="proQty" name="proQty" ></input>
                        </div>
                        <div className="col-lg-2">Pro.Value
                            <input type="number" className="form-control" id="proValue" name="proValue" ></input>
                        </div>
                        
                        <div className="col-lg-2">Sales.Qty
                            <input type="number" className="form-control" id="salesQty" name="salesQty" ></input>
                        </div>
                        <div className="col-lg-2">Sales.Value
                            <input type="number" className="form-control" id="salesValue" name="salesValue" ></input>
                        </div>

                        <hr className="my-3"/>
                        <div className="col-lg-2">Finish Goods Qty
                            <input type="number" className="form-control" id="finishGoodsQty" name="finishGoodsQty" ></input>
                        </div>
                        <div className="col-lg-2">Finish Goods Value
                            <input type="number" className="form-control" id="finishGoodsValue" name="finishGoodsValue" ></input>
                        </div>
                        
                        <div className="col-lg-2">Others Pro.Value
                            <input type="number" className="form-control" id="othersProValue" name="othersProValue" ></input>
                        </div>
                        <div className="col-lg-2">Others Sales.Value
                            <input type="number" className="form-control" id="othersSalesValue" name="othersSalesValue" ></input>
                        </div>
                        
                        <hr className="my-3"/>
                        <div className="col-lg-2">Work In Process(Qty)
                            <input type="number" className="form-control" id="workInProcessQty" name="workInProcessQty" ></input>
                        </div>    
                        <div className="col-lg-2">Profit/Loss
                            <input type="number" className="form-control" id="profitLoss" name="profitLoss" ></input>
                        </div>
                        <div className="col-lg-2">Con. National Exchequer 
                            <input type="number" className="form-control" id="conNationalExc" name="conNationalExc" ></input>
                        </div>

                        <div className="text-center">
                            <button class="my-2  btn btn-lg btn-info" type="submit">Save</button>
                        </div>

                    </div>
                </div>
                <div className="card-footer text-muted">Footer</div>
            </div>

        
        </>
    )

}


export default SalesProductionEntry;